import React, { useMemo, useState } from "react";

import { Select } from "antd";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { setChatSettings } from "../../../../appRedux/actions/ChatSettings";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

import IntlMessages from "@util/IntlMessages";
import { showName } from "@util/Scripts";

import "../ChatSettings/ChatStyle.less";
import { Message, Switch, Button, Spin, Input } from "../../../BP2Components";

//NOTE:

// in chat settings we need to overwrite bords object, becouse translations we use here are in boards object
// and not in actuall widget. so we cannot just overwrite widget settings

const AdvertisementListPublicChatSettings = (props) => {
   const [newBoard, setNewBoard] = useState({ ...props?.data });
   const [usersToAdd, setUsersToAdd] = useState(props?.value?.chatUsersColumnTechNames);
   const [chatActionSettings, setChatActionSettings] = useState({
      chatPublicButtonTitle: props?.value?.chatPublicButtonTitle,
      showPublicChatButton: props?.value?.showPublicChatButton,
      publicChatTitle: props?.value?.publicChatTitle,
      publicChatSubtitle: props?.value?.publicChatSubtitle
   });

   const selectOptions = [];

   const { allLanguages } = useSelector(({ settings }) => settings);

   const dispatch = useDispatch();
   const intl = useIntl();

   useMemo(() => {
      allLanguages.forEach((item) => {
         setChatActionSettings((prevState) => {
            return {
               ...prevState,
               [`name${item.language}`]: props?.data?.translations?.find(
                  (item) =>
                     Object.values(item).find(
                        (item) => item == props?.value?.chatPublicButtonTitle
                     ) == props?.value?.chatPublicButtonTitle
               )?.values?.[`${item.language}`]
            };
         });
      });
   }, []);

   const saveChatSettings = async () => {
      const changedSettings = { ...props?.data };
      const requiredWidget = props?.value;
      requiredWidget.showPublicChatButton = chatActionSettings?.showPublicChatButton;
      requiredWidget.publicChatTitle = chatActionSettings?.publicChatTitle;
      requiredWidget.publicChatSubtitle = chatActionSettings?.publicChatSubtitle;
      requiredWidget.chatUsersColumnTechNames = usersToAdd;

      const findTranslation = newBoard.translations.find(
         (item) => item.key == props?.value?.chatPublicButtonTitle
      );

      if (findTranslation) {
         findTranslation.values = allLanguages.reduce((target, key) => {
            target[key.language] = Object.entries(chatActionSettings).find(
               (item) => item[0] == `name${key.language}`
            )[1];
            return target;
         }, {});
      } else {
         newBoard.translations.push({
            category: null,
            key: chatActionSettings?.chatPublicButtonTitle,
            values: allLanguages.reduce((target, key) => {
               target[key.language] = Object.entries(chatActionSettings).find(
                  (item) => item[0] == `name${key.language}`
               )[1];
               return target;
            }, {})
         });
      }

      dispatch(setWidgetInSheetParams({ ...chatActionSettings }));
      setNewBoard({ ...changedSettings });
   };

   if (props) {
      props?.columns?.forEach((column, idx) => {
         if (column.title !== undefined) {
            selectOptions.push(
               <Select.Option key={idx} value={column.dataIndex}>
                  {column.title}
               </Select.Option>
            );
         }
      });
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      saveChatSettings(chatActionSettings);
      dispatch(setChatSettings(chatActionSettings));
      Message.success(intl.formatMessage({ id: "global.saved" }));
   };

   const handleSwitch = (checked, name) => {
      setChatActionSettings({ ...chatActionSettings, [name]: checked });
   };

   const handleChangeInput = (event, name) => {
      setChatActionSettings({ ...chatActionSettings, [name]: event.target.value });
   };

   const handleSelectTitle = (selectedTitle) => {
      setChatActionSettings({ ...chatActionSettings, publicChatTitle: selectedTitle });
   };

   const handleSelectSubTitle = (selectedSubTitle) => {
      setChatActionSettings({ ...chatActionSettings, publicChatSubtitle: selectedSubTitle });
   };
   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="showPublicChatButton" className="widget-settings__inner__label">
                     <IntlMessages id="Show chat button" />:
                     <Switch
                        name="showPublicChatButton"
                        onChange={(e) => handleSwitch(e, "showPublicChatButton")}
                        defaultChecked={chatActionSettings?.showPublicChatButton}
                     />
                  </label>
                  <label className="widget-settings__inner__label">
                     <IntlMessages id="Chat name" />:
                     <Input
                        style={{ width: "400px" }}
                        name="chatTitle"
                        defaultValue={chatActionSettings?.chatPublicButtonTitle}
                        disabled
                     />
                  </label>
                  {allLanguages ? (
                     allLanguages?.map((item) => {
                        return (
                           <label
                              key={item.language}
                              style={{ marginLeft: "60px" }}
                              className="widget-settings__inner__label"
                           >
                              <IntlMessages id={`Chat name ${item.language}`} />:
                              <Input
                                 style={{ width: "350px" }}
                                 type="translation"
                                 name={`name${item.language}`}
                                 defaultValue={
                                    chatActionSettings[`name${item.language}`]
                                       ? chatActionSettings[`name${item.language}`]
                                       : showName(
                                            `${item.language}`,
                                            chatActionSettings.chatPublicButtonTitle,
                                            chatActionSettings
                                         )
                                 }
                                 onChange={(e) => handleChangeInput(e, `name${item.language}`)}
                              />
                           </label>
                        );
                     })
                  ) : (
                     <div className="no-translations">
                        <Input
                           style={{ width: "400px" }}
                           name="chatTitle"
                           defaultValue={intl.formatMessage({
                              id: "no.translations.available"
                           })}
                           disabled
                        />
                     </div>
                  )}

                  <label style={{ marginLeft: "30px" }} className="widget-settings__inner__label">
                     <IntlMessages id="chat.list.settings.title" />:
                     <Select
                        defaultValue={chatActionSettings?.publicChatTitle}
                        style={{ width: "400px" }}
                        onChange={(e) => handleSelectTitle(e)}
                     >
                        {selectOptions === undefined ? <Spin /> : selectOptions}
                     </Select>
                  </label>
                  <label style={{ marginLeft: "8px" }} className="widget-settings__inner__label">
                     <IntlMessages id="settings.subtitleAdvertismentList" />:
                     <Select
                        defaultValue={chatActionSettings?.publicChatSubtitle}
                        style={{ width: "400px" }}
                        onChange={(e) => handleSelectSubTitle(e)}
                     >
                        {selectOptions === undefined ? <Spin /> : selectOptions}
                     </Select>
                  </label>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};
export default AdvertisementListPublicChatSettings;
